export default "__VITE_ASSET__f8b5fd9e__"